var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "task-prop task-prop-priority" }, [
    _c("strong", [_vm._v("Приоритет:")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "priority-slider" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("VueSlider", {
          attrs: {
            disabled: _vm.disable,
            data: _vm.allowedPriority,
            marks: true,
          },
          on: {
            "drag-end": function ($event) {
              return _vm.update()
            },
            change: function ($event) {
              return _vm.update()
            },
          },
          model: {
            value: _vm.editable,
            callback: function ($$v) {
              _vm.editable = $$v
            },
            expression: "editable",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "priority-slider__range" }, [
      _c("span", [_vm._v("высокий")]),
      _vm._v(" "),
      _c("span", [_vm._v("низкий")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }